import React from 'react';
import PropTypes from "prop-types";
import {Button, Checkbox, Popup} from "semantic-ui-react";
import _ from "lodash";
import {connect} from "react-redux";
import MARVEL from "../../../common/utils/MarvelUrls";
import {fetchAssociatedServiceIds} from "../actions/BillingOrganizationsActions";
import {resetPDFPortal} from "../../../report-generation/veritas-report-gen/ReportGeneratorActions";
import {ReportsType} from "../../../report-generation/veritas-report-gen/ReportGeneratorActionConstants";

const COUNTRIES = require("../../../common/resources/countries.json");

export class TenantsAndConfigsRow extends React.Component {

    // React's built-in state targeted to toggle the pdf report gen button on hover
    state = {
        isHovered: false,
        tenant_name: "",
    }

    static propTypes = {
        tenant: PropTypes.object,
        tenantName: PropTypes.string,
        configName: PropTypes.string,
        tenantID: PropTypes.number,
        configID: PropTypes.number,
        isSelected: PropTypes.bool,
        onToggleSelect: PropTypes.func,
    }


    handlePDFReportClick = () => {
        this.props.getAssociatedServiceIdsFromTenantName(this.state.tenant_name, ReportsType.PDF);
    }

    handleTenantsXLSReportClick = () => {
        this.props.getAssociatedServiceIdsFromTenantName('external', this.state.tenant_name, ReportsType.XLSX);
    }

    handleInternalTenantsXLSReportClick = () => {
            this.props.getAssociatedServiceIdsFromTenantName('internal', this.state.tenant_name, ReportsType.XLSX);
        }


    get tenantServicesReport() {
        const {tenantName, isDPEditor} = this.props
        return (
            <td
                onMouseEnter={() => this.setState({
                    tenant_name: tenantName,
                    isHovered: true
                })}
                onMouseLeave={() => this.setState({
                    tenant_name: "",
                    isHovered: false
                })}
            >
                <div>
                    <Popup
                        content={"Generate PDF Report"}
                        trigger={
                            <Button
                                icon="file pdf outline" size="big"
                                onClick={this.handlePDFReportClick}
                            />
                        }
                    />
                    <Popup
                        content={"Generate External-Use Excel Report"}
                        trigger={
                            <Button
                                icon="file excel outline" size="big"
                                onClick={this.handleTenantsXLSReportClick}
                            />
                        }
                    />
                    { isDPEditor ? (
                        <Popup
                            content={"Generate Internal-Only Excel Report"}
                            trigger={
                                <Button
                                    icon="file excel outline" size="big"
                                    onClick={this.handleInternalTenantsXLSReportClick}
                                />
                            }
                        />
                    ) : null}
                </div>
            </td>
        )
    }

    get associatedCountries() {
        const {tenant} = this.props;
        let formattedCountries = [];
        // show countries below the tenant name if available
        if (tenant.countries !== null) {
            const countriesArr = tenant.countries.split(',')
            countriesArr.forEach(countryCode => {
                let countryLabel = _.result(_.find(COUNTRIES, {
                    'value': countryCode
                }), 'label');
                formattedCountries.push(countryLabel);
            });
            formattedCountries = formattedCountries.join(", ")
        }
        return formattedCountries;
    }

    get tenantName() {
        const { tenantID, tenantName } = this.props;
        return (
            <td>
                <a
                    target="_blank" rel="noopener noreferrer"
                    href={MARVEL.CONFIG_TOOL.routeToTenantDetail + tenantID}>
                    {tenantName}</a>
                <p>{this.associatedCountries}</p>
            </td>
        )
    }

    get configName() {
        const { configID, configName } = this.props;
        return (
            <td>
                <a
                    target="_blank" rel="noopener noreferrer"
                    href={MARVEL.CONFIG_TOOL.routeToConfigDetail + Number(configID)
                    + MARVEL.CONFIG_TOOL.configDetailParams + Number(configID)}>
                    {configName}</a>
            </td>
        )
    }

    render() {
        const { tenantID, isSelected, onToggleSelect } = this.props;
        return (
            <tr>
                <td>
                    <Checkbox
                        checked={isSelected ?? false}
                        onChange={(e, { checked }) => onToggleSelect(String(tenantID), checked)}
                    />
                </td>
                {this.tenantServicesReport}
                {this.tenantName}
                {this.configName}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    isDPEditor: state.marvel.user.access.accessLevel.isDPEditor,
});

const mapDispatchToProps = dispatch => ({
    getAssociatedServiceIdsFromTenantName: (useCase, tenantName, type) => {dispatch(fetchAssociatedServiceIds(useCase, tenantName, type))},
    resetPDFPortal: () => {dispatch(resetPDFPortal())}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TenantsAndConfigsRow)

